import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { TypedMemo } from '../../common/types';
import { toggleSMLPricingModal } from '../../../redux/slices/appInfo/slice';
import { welcomeMessages as messages } from './welcomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole welcome page; each part uses its own slice of it */
import styles from './WelcomeView.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The calm line for a person whose signup trial was refused because the email already had one
 * (onboarding review 2026-10-19, finding 1). "See the plans" opens the plan picker of the page.
 */
const WelcomeTrialNoteComponent: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const openPlans = useCallback(() => {
    dispatch(toggleSMLPricingModal({ shouldShow: true }));
  }, [dispatch]);
  return (
    <div className={styles.info} role="note" data-testid="welcome-trial-note">
      <FontAwesomeIcon icon={faCircleInfo} />
      <span>
        {intl.formatMessage(messages.trialAlreadyUsed)}{' '}
        <button type="button" className={styles.link} onClick={openPlans}>
          {intl.formatMessage(messages.trialSeePlans)}
        </button>
      </span>
    </div>
  );
};

export const WelcomeTrialNote = TypedMemo(WelcomeTrialNoteComponent);
